/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Okta_Step3Inputs */



/**
* | output |
* | --- |
* | "Enter the SCIM connector base URL:" |
*
* @param {Scim_Setup_Okta_Step3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_okta_step3 = /** @type {((inputs?: Scim_Setup_Okta_Step3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Okta_Step3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die SCIM-Connector-Basis-URL ein:")
	return /** @type {LocalizedString} */ ("Enter the SCIM connector base URL:")
});